import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as NewRoute from "./new";
import * as ListRoute from "./list";
import * as DomainRoute from "./domain";
import DomainPublicSchema from "@common/schema/domain/public";
import * as Section from "@repoflow/components/section";

const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  const base = `/domain`;
  const basepath = `/domain`;

  return (
    <Section.Provider
      schema={DomainPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:domain`} component={DomainRoute.Content} />
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <>
            <BreadcrumbItem>
              <Link to={base}>Domains</Link>
            </BreadcrumbItem>
            <Switch>
              <Route path={`${basepath}/new`} component={NewRoute.Indice} />
              <Route
                path={`${basepath}/:domain`}
                component={DomainRoute.Indice}
              />
              <Route path={`${basepath}/`} component={ListRoute.Indice} />
            </Switch>
          </>
        </>
      )}
    </LocalProvider>
  );
}
export const Sidebar = () => <></>;
